import { MenuItemData } from '@components/Navigation';
import { mc, StyleProps } from '@styles';
import { TestIdProps } from '@utils';
import React, { FC, useState } from 'react';

import MobileMainMenu from './components/MainMenu';
import MobileTilesViewMenu from './components/TilesViewMenu';
import MobileTreeViewMenu from './components/TreeViewMenu';

interface Props extends StyleProps, TestIdProps {
  items: MenuItemData[];
  onClose?: () => void;
}

export const NavigationHeaderMobileMenu: FC<Props> = ({ testId, className, items, onClose }) => {
  const [selectedMenuItem, setSelectedMenuItem] = useState<MenuItemData | undefined>(undefined);
  return (
    <nav data-testid={testId} className={mc('overflow-y-auto bg-white', className)}>
      {!selectedMenuItem && <MobileMainMenu items={items} onMenuItemClick={setSelectedMenuItem} onLinkClick={onClose} />}
      {!!selectedMenuItem && selectedMenuItem.view === 'tree' && (
        <MobileTreeViewMenu item={selectedMenuItem} onGoBack={() => setSelectedMenuItem(undefined)} onLinkClick={onClose} />
      )}
      {!!selectedMenuItem && selectedMenuItem.view === 'tiles' && (
        <MobileTilesViewMenu item={selectedMenuItem} onGoBack={() => setSelectedMenuItem(undefined)} onLinkClick={onClose} />
      )}
    </nav>
  );
};

export type NavigationHeaderMobileMenuProps = Props;
export default NavigationHeaderMobileMenu;
